import React from "react";
import SignTranslationUsageModal from "./SignTranslationUsageModal";

const RequestPlaceholderUsageModal = ({ isOpen, request, onClose }) => (
  <SignTranslationUsageModal
    isOpen={isOpen}
    mode="request"
    entity={request}
    onClose={onClose}
  />
);

export default RequestPlaceholderUsageModal;
